<template>
	<main class="home">
		<section class="home__section home__section--profile">
			<Profile />
		</section>
	</main>
</template>

<script setup>
import Profile from '@/components/Profile.vue';
</script>
